import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import uiConfig from "./config/ui";
import { startGlobalSelect2 } from "./utils/select2";
import "apexcharts/dist/apexcharts.css";
import "./styles/tailwind.css";

const app = createApp(App);

// Make UI config globally available
app.config.globalProperties.$uiConfig = uiConfig;

app.use(router).mount("#app");
startGlobalSelect2(router);
